(() => {
  'use strict';
  if (customElements.get('wellhome-commerce')) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /*
    El carrusel de Top ventas avanzaba solo cada 5 segundos y pintaba un boton
    "Pausar" / "Reanudar" para poder detenerlo. Se ha quitado todo: el avance
    automatico, el temporizador, el boton y las paradas por hover, foco y pestana
    oculta que existian solo para sostenerlo.

    Motivo: un carrusel que se mueve mientras intentas leer un producto obliga a
    perseguir el contenido, y peleaba ademas con la barra de arrastre. El boton de
    pausa no era una solucion, era el parche de un problema que no hacia falta tener:
    solo aparecia para apagar algo que nadie habia pedido que se encendiera.

    El desplazamiento ahora es siempre del usuario: arrastrando la barra, con el
    trackpad o con las flechas del teclado sobre el carril, que lleva `tabindex="0"`.

    Con esto `wellhome-carousel.js` queda como unico responsable del carrusel de la
    home, igual que en la ficha de producto.
  */
  class WellHomeCommerce extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.setupCarousels();
      this.setupHotspots();
      this.setupParallax();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      if (this.parallaxFrame) window.cancelAnimationFrame(this.parallaxFrame);
    }

    setupCarousels() {
      this.querySelectorAll('[data-carousel]').forEach((carousel) => window.WellHomeCarousel?.setup(carousel));
    }

    setupHotspots() {
      const { signal } = this.controller;
      const buttons = Array.from(this.querySelectorAll('[data-hotspot-button]'));
      const closeAll = (exception) => buttons.forEach((button) => {
        if (button === exception) return;
        button.setAttribute('aria-expanded', 'false');
        const popover = button.parentElement.querySelector('[data-hotspot-popover]');
        if (popover) popover.hidden = true;
      });

      buttons.forEach((button) => button.addEventListener('click', (event) => {
        event.stopPropagation();
        const expanded = button.getAttribute('aria-expanded') === 'true';
        closeAll(button);
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        const popover = button.parentElement.querySelector('[data-hotspot-popover]');
        if (popover) popover.hidden = expanded;
      }, { signal }));
      document.addEventListener('click', () => closeAll(), { signal });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeAll();
      }, { signal });
    }

    setupParallax() {
      const { signal } = this.controller;
      const banner = this.querySelector('[data-scroll-banner]');
      const floating = Array.from(this.querySelectorAll('[data-floating]'));
      if (!banner || !floating.length || reducedMotion.matches) return;

      const update = () => {
        const rect = banner.getBoundingClientRect();
        const viewport = window.innerHeight || document.documentElement.clientHeight;
        const progress = Math.min(1, Math.max(0, (viewport - rect.top) / (viewport + rect.height)));
        floating.forEach((item) => {
          const shift = Number.parseFloat(getComputedStyle(item).getPropertyValue('--wh-shift')) || 0;
          item.style.setProperty('--wh-parallax', `${(progress - 0.5) * shift * 2}px`);
        });
        this.parallaxFrame = null;
      };
      const requestUpdate = () => {
        if (!this.parallaxFrame) this.parallaxFrame = window.requestAnimationFrame(update);
      };
      window.addEventListener('scroll', requestUpdate, { passive: true, signal });
      window.addEventListener('resize', requestUpdate, { passive: true, signal });
      requestUpdate();
    }
  }

  customElements.define('wellhome-commerce', WellHomeCommerce);
})();
